import { DeleteOutlined, PlusOutlined } from "@ant-design/icons"
import {
  Button,
  Empty,
  Flex,
  Form,
  type FormListFieldData,
  type FormListOperation
} from "antd"
import type { FormInstance } from "antd/es/form/hooks/useForm"
import React from "react"

import { formListAddFocus } from "../../../../../utils/form/form-list-add-focus.ts"
import { type TemplateDocumentFormData } from "../../../types/template-document-form-data.tsx"
import { TextInput } from "../../../../../components/Input/TextInput.tsx"

interface DocumentListSectionProps {
  form: FormInstance<TemplateDocumentFormData>
  name: keyof TemplateDocumentFormData
  infoFieldName?: string[]
  infoPlaceholder?: string
  itemPlaceholder?: string
  addButtonText?: string
  bulletChar?: string
}

export function DocumentListSection({
  form,
  name,
  infoFieldName,
  infoPlaceholder,
  itemPlaceholder = "Enter item",
  addButtonText = "Item",
  bulletChar = "•"
}: DocumentListSectionProps) {
  const id = Array.isArray(name) ? name.join("_") : name

  return (
    <>
      {infoFieldName && (
        <Form.Item name={infoFieldName}>
          <TextInput placeholder={infoPlaceholder} />
        </Form.Item>
      )}

      <Form.List name={name}>
        {(fields, { add, remove }) => (
          <>
            {fields?.length ? (
              <Flex id={id} vertical gap={8}>
                {fields.map(({ key, ...field }) => (
                  <Flex gap={3} key={key} className="pb-2" align="center">
                    <span className={"text-lg"}>{bulletChar}</span>
                    <Form.Item
                      {...field}
                      className="mb-0 flex-1"
                      rules={[
                        { required: true, whitespace: true, message: "" }
                      ]}
                    >
                      <TextInput placeholder={itemPlaceholder} />
                    </Form.Item>
                    <Button
                      danger
                      icon={<DeleteOutlined />}
                      onClick={() => {
                        remove(field.name)
                        form.validateFields([name])
                      }}
                    />
                  </Flex>
                ))}
              </Flex>
            ) : (
              <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
            )}
            <Button
              className="w-full"
              type="dashed"
              onClick={() => {
                formListAddFocus<TemplateDocumentFormData>(
                  add,
                  fields,
                  form,
                  name
                )
                form.validateFields([name])
              }}
              icon={<PlusOutlined />}
            >
              {addButtonText}
            </Button>
          </>
        )}
      </Form.List>
    </>
  )
}
